/**
 * One-shot incoming-message ding (ENG-2946) — shared by the widget (agent
 * message arrives) and the CC agent view (message in an assigned/open chat).
 *
 * Plays the SAME sound v2 uses (`message_alert.m4a`, 50% volume — see the v2
 * chat's MessageHandler.playDing), so v2 → v3 sounds identical to users and
 * agents. Deliberately distinct from the CC's looping escalation hoot.
 *
 * Browsers block audio until the page has had a user gesture — `play()`
 * failures are swallowed by design (a widget visitor who has never clicked
 * simply doesn't get a sound yet).
 */

const DING_SOUND_URL = "https://swivl-cdn.s3-us-west-1.amazonaws.com/message_alert.m4a";
const DING_VOLUME = 0.5;
const DING_THROTTLE_MS = 400;

let dingAudio: HTMLAudioElement | null = null;
let lastDingAt = 0;

export function playMessageDing(): void {
  const now = Date.now();
  if (now - lastDingAt < DING_THROTTLE_MS) return;
  lastDingAt = now;

  try {
    if (!dingAudio) {
      dingAudio = new Audio(DING_SOUND_URL);
      dingAudio.volume = DING_VOLUME;
      dingAudio.preload = "auto";
    }
    dingAudio.currentTime = 0;
    void dingAudio.play().catch(() => {});
  } catch {
    /* audio unavailable (autoplay policy, no device) — sound is best-effort */
  }
}
